// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const burmy: PokeData = {
  "id": 412,
  "name": "burmy",
  "height": 2,
  "weight": 34,
  "base_experience": 45,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "string-shot",
    "protect",
    "hidden-power",
    "bug-bite",
    "struggle-bug"
  ],
  "moves": [
    "tackle",
    "string-shot",
    "protect",
    "bug-bite",
    "lunge",
    "leech-steal",
    "sticky-web",
    "pin-rush",
    "bug-buzz",
    "pounce",
    "heal-order",
    "signal-spam",
    "pin-missile"
  ],
  "evolution_chain": {
    "id": 213,
    "item": null,
    "species": [
      {
        "name": "burmy",
        "order": 440,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wormadam",
        "order": 441,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 412,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      },
      {
        "name": "mothim",
        "order": 442,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 412,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "male"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 36,
    "ability_power": 29
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
